// extracted by mini-css-extract-plugin
export default {"ffb800":"DeploymentOption_ffb800__HUV2i"};